module.exports = __webpack_public_path__ + "static/media/codeClock.c7e74f00.gif";